/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdescriptionlabel2Inputs */

const en_dropdescriptionlabel2 = /** @type {(inputs: Dropdescriptionlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop description (detail page text)`)
};

const de_dropdescriptionlabel2 = /** @type {(inputs: Dropdescriptionlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-Beschreibung (Text auf der Detailseite)`)
};

/**
* | output |
* | --- |
* | "Drop description (detail page text)" |
*
* @param {Dropdescriptionlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdescriptionlabel2 = /** @type {((inputs?: Dropdescriptionlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdescriptionlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdescriptionlabel2(inputs)
	return de_dropdescriptionlabel2(inputs)
});
export { dropdescriptionlabel2 as "dropDescriptionLabel" }